import { Button, Icon, Modal } from 'antd';
import React from 'react';
import { FolderSelectionModal } from '../../../../../components/ContentMenu/FolderSelection/FolderSelectionModal';
import { ContentType } from '../../../../../enums/ContentType';
import { ContentSearchResult } from '../../../../../models/ContentSearchResult';
import { ArticleType } from '../../../../pesquisa/enums/ArticleType';

export const AddToFolder = ({ options }) => {
  const getResult = (it: any) => {
    if (!Object.keys(it).length) return;

    const base = `https://${process.env.REACT_APP_PUBLIC_BUCKET}.s3-sa-east-1.amazonaws.com`;

    return {
      url: '',
      subTitle: '',
      formattedDate: '',
      total: 0,
      parentId: it.id,
      editionId: '',
      relevantWords: null,
      contentType: ContentType.CODE,
      articleType: ArticleType.TODOS,
      id: it.id,
      title: it.text_1,
      text: it.text_2,
      tags: [{ text: 'Código', color: '' }],
      img: it.img,
      author: '',
      areasInterest: ''
    };
  };

  const close = () => {
    options.setShowAddToFolder(false);
  };

  const footer = [
    <Button type={'primary'} key={'btn-1'} onClick={close}>
      <Icon type="close" />
      Fechar
    </Button>
  ];

  const result: ContentSearchResult = getResult(options.folderItem);

  return (
    <Modal
      maskClosable={true}
      title="Adicionar à pasta"
      visible={options.showAddToFolder}
      onCancel={close}
      onOk={close}
      footer={footer}
      maskStyle={{ background: 'rgba(0,0,0,.2)' }}>
      <FolderSelectionModal
        result={result}
        visible={options.showAddToFolder}
        onCancel={close}
      />
    </Modal>
  );
};
